<template>
  <span>
    <a v-if="isAuthenticated" @click="logout" class="button is-primary">
      <strong>
        <awesome-icon class="button-icon" icon="sign-in-alt"/>Se déconnecter
      </strong>
    </a>
    <a v-else @click="login" class="button is-primary">
      <strong>
        <awesome-icon class="button-icon" icon="sign-in-alt"/>Se connecter
      </strong>
    </a>
  </span>
</template>

<script>
import { getCurrentInstance, ref, onMounted, watch } from 'vue'
import { getInstance } from '../auth'

export default {
  setup() {
    const isAuthenticated = ref(false)

    // getCurrentInstance pour accéder au store
    const internalInstance = getCurrentInstance()
    if (!internalInstance) {
      throw new Error("Must be called inside setup")
    }

    const login = async () => {
      const auth = getInstance()
      await auth.loginWithRedirect()
    }

    const logout = () => {
      // dispatch logout dans store
      internalInstance.appContext.config.globalProperties.$store.dispatch('account/logoutAuth0User')
    }

    onMounted(() => {
      const auth = getInstance()
      
      // Surveiller les changements de façon réactive
      watch(() => auth.isAuthenticated, (newValue) => {
        isAuthenticated.value = newValue
      }, { immediate: true })

    })

    return {
      login,
      logout,
      isAuthenticated
    }
  }
}
</script>

<style scoped>

</style>